import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHandshake, faUsers } from '@fortawesome/free-solid-svg-icons';
import './PorQueElegirnos.css';

export default function PorQueElegirnos() {
    const diferenciales = [
        {
            icon: faEye,
            titulo: "Transparencia",
            descripcion: "Información clara y detallada de cada vehículo"
        },
        {
            icon: faHandshake,
            titulo: "Sencillez",
            descripcion: "Métodos de pago, financiación, y nos encargamos de todo por vos"
        },
        {
            icon: faUsers,
            titulo: "Asesoramiento Personalizado",
            descripcion: "Nuestro equipo te guía paso a paso en todo el proceso"
        }
    ];

    return (
        <section className='por-que-elegirnos-section'>
            <div className='por-que-elegirnos-container'>
                <div className='por-que-elegirnos-content'>
                    <div className='por-que-elegirnos-text'>
                        <h2 className='por-que-elegirnos-title'>COMPRA TU AUTO EN FILONI</h2>
                        <p className='por-que-elegirnos-subtitle'>
                            En Filoni te ofrecemos calidad, comodidad y seguridad para que compres con confianza.
                        </p>

                        <div className='diferenciales-grid'>
                            {diferenciales.map((item, index) => (
                                <div
                                    key={index}
                                    className='diferencial-item'
                                    style={{ '--delay': `${index * 0.1}s` }}
                                >
                                    <div className='diferencial-item-content'>
                                        <div className='diferencial-icon-container'>
                                            <FontAwesomeIcon icon={item.icon} className='diferencial-icon' />
                                        </div>
                                        <div className='diferencial-content'>
                                            <h4 className='diferencial-titulo'>{item.titulo}</h4>
                                            <p className='diferencial-descripcion'>{item.descripcion}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}